import {ReactNode} from 'react';

import {useUpdateNotesPopup} from './UpdateNotesProvider.hook';

interface UpdateNotesProviderProps {
  children?: ReactNode;
}

export const UpdateNotesProvider: React.FC<UpdateNotesProviderProps> = ({
  children = null,
}) => {
  useUpdateNotesPopup();

  return children;
};

export default UpdateNotesProvider;
